import React from 'react';
const SCMessageBarContext = React.createContext(null);
export default SCMessageBarContext;
